<template>
	<div class="chat__messages-list-wrapper">
		<template v-if="messages" >
			<div class="chat__message"
				v-for="message in messages"
				:key="message.id"
			>
				<chat-message
					:message="message"
					@intersected="intersected"
					:users="users"
					@startDelete="startDelete"
					@previewImage="previewImage"
					@deleteImage="deleteImage"
					@deleteAttachment="deleteAttachment"
					:list-key="listKey"
					:is-public="isPublic"
					:is-direct="isDirect"
					/>
			</div>
		</template>
		<delete-message-dialog ref="dialog" />
	</div>
</template>

<script>
import ChatMessage from '@/components/chat/messenger/partials/ChatMessage';
import DeleteMessageDialog from '@/components/chat/dialogs/DeleteMessageDialog';
export default {
	props: {
		messages: {
			required: true,
			type: Array
		},
		users: {
			required: true,
			type: Array
		},
		isPublic: {
			type: Boolean,
			default: false
		},
		isDirect: {
			type: Boolean,
			default: false
		}
	},
	components: {
		ChatMessage,
		DeleteMessageDialog
	},
	data() {
		return {
			listKey: 0
		}
	},
	watch: {
		messages(newVal, oldVal) {
			if(oldVal.length != newVal.length) {
				this.listKey++
			}
		}
	},
	methods: {
		deleteImage(image, message) {
			this.$emit('deleteImage', image, message);
		},
		deleteAttachment(attachment, message) {
			this.$emit('deleteAttachment', attachment, message);
		},
		previewImage(image) {
			this.$emit('previewImage', image)
		},
		intersected(id, isIntersecting) {
			this.$emit('intersected', id, isIntersecting)
		},
		startDelete(message) {
			this.$refs['dialog'].showDialog(message);
		}
	}
}
</script>

<style lang="scss">
	.chat__message {
		margin-bottom: 16px;
	}
</style>
